<div class="container" fxLayoutAlign="center center" fxLayoutGap="10px">
  <mat-icon>{{data.icon}}</mat-icon>
  <mat-label>{{data.message}}</mat-label>
</div>